const links = {
    links: [
        { name: "Home", link: "/" },
        {
            name: "Getting Started",
            link: "https://nest.nitk.ac.in/docs/master/user/tutorial.html",
            isExternal: true,
        },
        { name: "GSoC Project Ideas", link: "/gsoc" },
        { name: "Contributing", link: "/contributing" },
        { name: "Contributors", link: "/contributors" },
    ],
};
export default links;
